import React, { useState } from 'react';
import { CopyIcon, CheckIcon } from 'lucide-react';
interface CopyButtonProps {
  value: string;
  size?: 'sm' | 'md';
}
export function CopyButton({
  value,
  size = 'sm'
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  return <button type="button" onClick={handleCopy} className="p-1 text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300 transition-colors rounded hover:bg-slate-100 dark:hover:bg-slate-800" aria-label="Copy to clipboard" data-id="element-38">
      {copied ? <CheckIcon className={`${iconSize} text-green-600 dark:text-green-500`} data-id="element-39" /> : <CopyIcon className={iconSize} data-id="element-40" />}
    </button>;
}